import { Outlet } from 'react-router-dom';
import { Layout, Menu } from 'antd';


const CustomLayout = () => {

  return (
    <>
      <Outlet />
    </>
  );
};

export default CustomLayout;
